import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import Stack from "../../components/ui/Stack";
import {loginSchema} from "../../schema/loginSchema";
import {loginFormModel} from "../../models/loginModel";
import Form from "../../components/common/form/Form";
import {fetchToken, getUserRole, login} from "../../store/auth-slice";
import {useNavigate} from "react-router-dom";
import {setLoading} from "../../store/utility-slice";


const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(fetchToken());
        dispatch(getUserRole());
    },[dispatch]);

    const {
        isValid,
        loginStatus,
        error
    } = useSelector(state => state.auth);

    useEffect(() => {
        isValid === false && navigate("/login");
        isValid === false && dispatch(setLoading(false));
        isValid === true && (navigate("../"));
    },[dispatch,isValid,navigate]);

    const formSubmitHandler = (data) => {
        dispatch(login(data));
    }
    const initialData = loginFormModel();
    const schema = loginSchema();

    return (
        <div className="container-fluid p-0 vh-100" >
            <div className="row h-100 g-0">
                <div className="col">
                    <Stack className="align-items-center justify-content-center h-100">
                        <div className="card mb-7 bg-white border-0 rounded-4">
                            <div className="card-body p-6" style={{width: "400px"}}>
                                <h4 className="text-center fw-semibold mb-3">Welcome back!</h4>
                                <p className="fs-md opacity-50 fw-medium mb-4 text-center">Sign in to continue</p>
                                <Form onFormSubmit={formSubmitHandler}
                                      schema={schema}
                                      initialData={initialData}
                                      status={loginStatus}
                                      error={error}/>
                                <a href="/signUp" className="text-dark text-opacity-75 fs-sm">Don’t have an account Sign up</a>
                            </div>
                        </div>
                    </Stack>
                </div>
            </div>
        </div>
    )
};
export default Login;
